class StickyHeader {
  constructor() {
    this.process();

    $(window).scroll(() => {
      this.process();
    });
  }

  process() {
    if ($(document).width() > 991) {
      if ($(document).scrollTop() < 75) {
        $('[data-main-header]').removeClass("sticky");
      } else {
        $('[data-main-header]').addClass("sticky");
      }
    }
  }
}

function addRedirectUrls() {
  $('[data-add-redirect-url]').each(function() {
    const href = $(this).attr('href');
    $(this).attr('href', `${href}?redirectFrom=${encodeURIComponent(window.location.href)}`);
  });
}

class FormButtons {
  formWidth = 1100;
  formHeight = 650;
  formSelector = '[data-popup-contact]';

  constructor() {
    const _this = this;

    $(document).on('click', _this.formSelector, function(e, el) {
      e.preventDefault();
      window.open($(this).attr('href'), '_blank', `width=${_this.formWidth},height=${_this.formHeight}`);
    });
  }
}

class HeadMenu {

  constructor() {
    this.$mobileBtn = $('[data-mobile-menu-button]');
    this.$menu = $('[data-head-menu]');
    this.$submenuBtn = $('[data-head-menu-subbutton]');

    this.addEvents();
  }

  addEvents() {
    const _this = this;
    this.$mobileBtn.on('click', (e) => {
      e.stopPropagation();
      if (this.$mobileBtn.hasClass('open')) {
        this.closeMobileMenu();
      } else {
        this.openMobileMenu();
      }
    });

    this.$submenuBtn.click(function(e) {
      e.preventDefault();
      e.stopPropagation();
      _this.toggleSubmenu($(this));
    })

    $(document).click(function() {
      _this.closeMobileMenu();
    });
  }

  openMobileMenu() {
    this.$mobileBtn.addClass('open');
    this.$menu.addClass('open');
    $('html').addClass('scrollLock')
  }

  closeMobileMenu() {
    this.$mobileBtn.removeClass('open');
    this.$menu.removeClass('open');
    $('html').removeClass('scrollLock')
  }

  toggleSubmenu($btn) {
    if ($btn.hasClass('expanded')) {
      $btn.removeClass('expanded');
      $btn.closest('li').find('ul').slideUp();
    } else {
      $btn.addClass('expanded');
      $btn.closest('li').find('ul').slideDown();
    }
  }

}

class offerDescription {
  heightBreakpoint = 600;

  constructor() {
    const _this = this;

    $('[data-offer-description]:not(.initialized)').each(function() {
      const $root = $(this);
      $root.addClass('initialized');

      if ($root.outerHeight() <= _this.heightBreakpoint) {
        $root.find('[data-offer-description-overlay]').remove();
      } else {
        $root.addClass('collapsed');
        _this.addEvents($root);
      }
    });
  }

  addEvents($root) {
    $root.find('[data-offer-description-button]').click(function() {
      $root.removeClass('collapsed');
      $root.find('[data-offer-description-overlay]').fadeOut();
    });
  }
}


readyCallbacks.add(() => {
  new StickyHeader();
  addRedirectUrls();
  new FormButtons();
  new HeadMenu();
  new offerDescription();

  $('[data-contactform]:not(.initialized)').contactForm();

  $('.customSelect').select2({
    minimumResultsForSearch: Infinity
  });
});
